module.exports = __webpack_public_path__ + "img/政务.fbc99f42.png";